import {Link as LinkProps} from '@aboutyou/grpc-clients/tadarida/aysa_api/features/link/v1/link.types';
import {
  LinkProps as ReactLinkProps,
  Link as RouterLink,
} from '@aboutyou/router';
import React, {FC} from 'react';

interface HtmlLinkProps {
  onClick?: ReactLinkProps['onClick'];
  className?: string;
}

export const Link: FC<
  React.PropsWithChildren<Omit<LinkProps, 'color'> & HtmlLinkProps>
> = ({label, linkTarget, children, ...rest}) => {
  return (
    <RouterLink to={linkTarget!.url} {...rest}>
      {label || children || linkTarget!.url}
    </RouterLink>
  );
};
